import React, { Component } from 'react';
class text extends Component{

  render() {
      return (
          <div className="about-div">
            <h1>About  Yantra</h1>
            <br/>
            <p className="font-17">
              The word "Yantra" is derived from two Sanskrit words - "Yam" means "to support" and "Trana" means "Freedom".
            </p>
            <p className="font-17">
              A Yantra is a form of mandals, and there are two types of Yantra:
            </p>
            <br/>
            <span className="about_subtitle"><span className="ab_number"> 1 </span>  Pictorial Yantra </span>
            <br/>
            <p className="des_yan">
              A pictorial Yantra, which is a symbolic diagram, usually used to assist meditation.
            </p>
            <br/>
            <span className="about_subtitle"><span className="ab_number b_yellow"> 2 </span>  Numerological Yantra </span>
            <br/>
            <p className="des_yan">
              Magic Square, or numerological Yantras.
            </p>
            <br/>
            <p className="font-17">
              Numerological yantras can be used only for divination but also worn as a talisman. The purpose of a talisman is twofold- to protect
              and strengthen the wearer, and to attract to the person what he or she wants.
            </p>
            <br/>
            <p className="font-17">
              For thousands of years people have carried their own yantras with them for protection and good luck. By making and using these
              magic squares(yantras) you will be taking part in an ancient tradition that is as relevant today as it has ever been in the past.
            </p>
          </div>
      )
  }
}

      
export default text;


// WEBPACK FOOTER //
// ./src/components/About/text.js